import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { transformExtent, fromLonLat, transform, toLonLat } from 'ol/proj';
import { toLine, getImg, formatRGBA, getformatstruct, getformitemsdata, getformListItemsdatas, bd_decrypt } from '@/utils/utils';
import { mapState, mapGetters, mapMutations } from 'vuex';
import mapv2assembly from '@/view/map/hdmconfigv2/map';
import mappopupv2 from '@/components/mapv2/popupv2/index';
import typev2 from '@/components/mapv2/typev2/index';
import axios from 'axios';
import { BMapLoader } from '@/utils/bdMap.js';
export default {
  name: 'weinan',
  components: {
    mapv2assembly,
    mappopupv2,
    typev2
  },
  props: {
    // 0配置页 1展示页
    id: {
      type: Number,
      default: 1
    },
    mapform: {
      type: Object,
      default: {}
    },
    style: {
      type: Object,
      default: {}
    },
    typelist: {
      type: Array,
      default: []
    },
    isloadingmap: {
      type: Boolean,
      default: false
    },
    maplayer: {
      type: Object,
      default: {}
    },
    viewInfo: {
      type: Object,
      default: {}
    },
    streetcode: {
      type: String,
      default: ''
    },
    mappointList: {
      type: Array,
      default: []
    },
    culturalList: {
      type: Array,
      default: []
    },
    maptemplate: {
      type: Number,
      default: 0
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isMobileflag: false,
      // 移动端判断
      query: '',
      formUserId: '',
      // 最外层样式
      mainStyle: {
        width: '',
        height: '',
        transform: 'scale(1)',
        transformOrigin: '0 0',
        position: 'relative'
      },
      // 除地图以外的数据集合
      mapelem: {
        bg: '',
        logo: '',
        pickey: '',
        golist: 'https://p.ananas.chaoxing.com/star3/origin/3df243657b8ae7d4bd4eccd3446f3639.png'
      },
      // 除地图以外的样式集合
      modulestyle: {
        logo: '',
        pickey: '',
        type: '',
        list: ''
      },
      cTemplateScore: 0,
      popmodeltype: 0,
      // 弹窗默认模板样式
      pointdetail: {},
      popshowflag: false,
      showtype: 1,
      modeltype: 0,
      showlist: 1,
      typebtn: [],
      showgolist: false,
      showgolistId: 0,
      cform: {},
      // 非遗项目表单数据
      cformlabel: {},
      // 非遗项目表单结构标题集合
      cformoption: {},
      // 非遗项目表单结构默认选择项值集合
      cformfield: {},
      // 非遗项目表单校验集合
      cstructList: [],
      // 非遗项目表单结构数据
      cpList: [],
      // 添加或编辑非遗项目表单数据时列表
      defaultcform: {},
      // 非遗项目默认form数据
      cformUser: {},
      // 地图配置当前行ID数据
      formatData: {},
      // 地图配置当前行ID 格式化数据
      sList: [],
      // 添加或编辑地图表单数据时列表
      form: {},
      // 地图表单数据
      formlabel: {},
      // 地图表单结构标题集合
      formoption: {},
      // 地图表单结构默认选择项值集合
      formfield: {},
      // 地图表单校验集合
      mapview: {},
      loadingmap: false,
      mapLayers: {},
      mapstyle: {},
      jsonOption: {},
      typeList: [],
      // 分类列表数据
      mapstreetcode: '',
      typeform: {
        formId: '260297',
        page: 1,
        limit: 100,
        searchStr: ''
      },
      // 分类列表查询字段
      pointform: {
        formId: '165054',
        page: 1,
        limit: 100,
        searchStr: ''
      },
      // 点位查询字段集合
      // 搜索定位点字段
      searchStr: {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': '40',
            'compt': 'editinput',
            'express': '===',
            'val': ''
          }]
        }, {
          "model": 1,
          "filters": []
        }]
      },
      coordinate: '',
      // 当前点击经纬度
      pointList: [],
      // 点位列表数据
      mapculturalList: [],
      // 非遗项目列表数据
      culturalform: {
        formId: 'cultural_heritage_project',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '57ed207dcf924429c45100c202c62142651c83312c7ae7d68a7aa7777892039a5066948fb3dc970fc240392e22722d5c'
      },
      // 非遗项目表单字段
      mapculturalpersonList: [],
      // 非遗人列表数据 culturalHeritageInheritor202405192327
      culturalpersonform: {
        formId: 'cultural_heritage_inheritor',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '57ed207dcf924429c45100c202c62142273459422eab738a2ef4681ff0d1e276d794a6b905f0918f3df30b1ce38395ba'
      },
      // 非遗人表单字段
      mapculturalpicList: [],
      // 项目图片列表数据 culturalpic2024052571429
      culturalpicform: {
        formId: '21416',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '0bef8d07ada7bc791d6ebf0bcc4c8a8a'
      },
      // 项目图片表单字段
      mapculturalvideoList: [],
      // 项目视频列表数据 culturalvideo202405281701
      culturalvideoform: {
        formId: '12479',
        page: 1,
        limit: 100,
        searchStr: '',
        t: 'ebc411877446a47bd84c8cb30c90410b'
      },
      // 项目视频表单字段
      culturalprojectData: [],
      culturalprojectDatalen: 0,
      culturalpersonData: [],
      culturalpersoncategory: [],
      culturalpersoncategorylen: 0,
      typeUlindex: 0,
      culturalprojectSum: 0,
      culturalpersonSum: 0,
      culturalarea: '',
      culturalworkshoplevel: [],
      culturalworkshoplevellen: 0
    };
  },
  computed: {
    ...mapGetters(['mapv2info'])
  },
  watch: {
    mapform: {
      handler(val) {
        if (val) {
          this.form = val;
          this.mapformHandle(val);
        }
      },
      deep: true
    },
    style: {
      handler(val) {
        if (val) {
          // console.log(`supermapstyle`, val);
          this.mapstyle = val;
          this.styleHandle(val);
        }
      },
      deep: true
    },
    'style.typebtn': {
      handler(val) {
        if (val) this.typebtnFormat(val);
      },
      deep: true
    },
    'style.popcolor'(val) {
      if (val) this.popcolorFormat(val);
    },
    viewInfo: {
      handler(val) {
        this.mapview = val;
      },
      deep: true
    },
    isloadingmap(val) {
      this.loadingmap = val;
    },
    maplayer: {
      handler(val) {
        this.mapLayers = val;
      },
      deep: true
    },
    typelist: {
      handler(val) {
        this.typeList = val;
      },
      deep: true
    },
    mappointList: {
      handler(val) {
        console.log(`mappointList`, val);
        this.pointList = val;
      },
      deep: true
    },
    culturalList: {
      handler(val) {
        this.mapculturalList = val;
      },
      deep: true
    },
    maptemplate(val) {
      this.cTemplateScore = val;
    },
    streetcode(val) {
      this.mapstreetcode = val;
    },
    isMobile(val) {
      this.isMobileflag = val;
      this.changeMobile(val);
    },
    'mapv2info.style.typebtn': {
      handler(val) {
        if (val) this.typebtnFormat(val);
      },
      deep: true
    },
    'mapv2info.style': {
      handler(val) {
        // console.log(`mapv2info.style`, val);
        if (val) {
          this.styleHandle(val);
        }
      },
      deep: true
    },
    'mapv2info.style.popcolor'(val) {
      if (val) this.popcolorFormat(val);
    }
  },
  created() {
    this.mapconStyle();
  },
  mounted() {
    this.query = this.$route.query;
    this.formUserId = this.query.formUserId;
    console.log(`this.id`, this.id);
    // 展示页请求相关接口数据
    if (this.id === 1) {
      this.setComonStyle();
      this.getMapData();
    }
    this.$nextTick(() => {
      this.loadBmap();
    });
  },
  methods: {
    ...mapMutations(['SET_MAPSENIOR', 'SET_MAPVIEW', 'SET_MAPFORM', 'SET_MAPFORMITEM', 'SET_MAPSTYLEITEM', 'SET_MAPDRAWLAYER', 'SET_COORDINATE']),
    loadBmap() {
      BMapLoader().then(BMap => {
        let BDMap = new BMap.Map('bdmap');
        let geolocation = new BMap.Geolocation();
        let bdmap = {};
        geolocation.getCurrentPosition(a => {
          console.log(a);
          bdmap.address = a.address;
          bdmap.lng = a.point.lng;
          bdmap.lat = a.point.lat;
          localStorage.setItem('bdlocation', JSON.stringify(bdmap));
        });
      });
    },
    mapconStyle() {
      this.mainStyle.width = `${window.innerWidth}px`;
      this.mainStyle.height = `${window.innerHeight}px`;
      if (window.innerWidth < 1081) this.isMobileflag = true;
    },
    percentageChange(scale) {
      this.mainStyle.transform = `scale(${scale})`;
    },
    /**
    * 定位点格式化
    */
    posFormat(val) {
      delete val.ptype;
      delete val.pIndex;
      return val;
    },
    popcolorFormat(val) {
      let obj = formatRGBA(val);
      let theme1 = `rgba(${obj.r},${obj.g},${obj.b},1)`;
      let theme2 = `rgba(${obj.r},${obj.g},${obj.b},0.7)`;
      document.documentElement.style.setProperty('--hand-drawn-pop-colortheme1', theme1);
      document.documentElement.style.setProperty('--hand-drawn-pop-colortheme07', theme2);
    },
    styleHandle(val) {
      this.popmodeltype = val.popStyleIndex === undefined ? this.form.cTemplateScore === 1 ? 1 : 0 : val.popStyleIndex;
      this.modeltype = val.typeStyleIndex === undefined ? 0 : val.typeStyleIndex;
      Object.keys(this.modulestyle).forEach(key => {
        let pos = this.posFormat({
          ...val[`${key}pos`]
        });
        let appPos = {};
        Object.keys(pos).forEach(item => {
          appPos[item] = this.isMobileflag ? `${parseFloat((parseInt(pos[item]) / 2 / 37.5).toFixed(6))}rem` : `${parseFloat((parseInt(pos[item]) / 1920 * 100).toFixed(6))}vw`;
        });
        this.modulestyle[key] = appPos;
        // this.modulestyle[key] = this.posFormat(Object.keys(val).length > 0 ? {...val[`${key}pos`]} : {...this.mapv2info.style[`${key}pos`]}) 
      });
    },
    mapformHandle(val) {
      if (!this.isMobileflag) {
        this.mapelem.bg = val.background_img && val.background_img.length > 0 ? getImg(val.background_img[0]) : '';
      }
      if (this.isMobileflag) {
        this.mapelem.bg = val.app_bg_img && val.app_bg_img.length > 0 ? getImg(val.app_bg_img[0]) : '';
      }
      this.mapelem.logo = val.logo && val.logo.length > 0 ? getImg(val.logo[0]) : '';
      this.mapelem.pickey = val.pickey && val.pickey.length > 0 ? getImg(val.pickey[0]) : '';
      this.showtype = val.showtype;
      this.showlist = val.showlist;
      this.isHasallarea(val);
      if (val.cTemplateScore === 1) this.getCulturalFormStruct();
    },
    changeMobile(val) {
      this.mapformHandle(this.form);
      if (val) {
        this.mainStyle.width = '375px';
        this.mainStyle.height = '667px';
      } else {
        this.mainStyle.width = `${window.innerWidth}px`;
        this.mainStyle.height = `${window.innerHeight}px`;
      }
    },
    markermoveend(val) {
      // 非遗模版 地点数据 无层级字段 禁止缩放获取层级数据
      if (this.id === 1) {
        if (this.form.cTemplateScore === 1) {
          this.culturalform.page = 1;
          // this.getIntangibleCulturalHeritageData()
          if (this.isMobileflag) this.removeDrawsource();
          return;
        }
        this.popshowflag = false;
        this.removeAlliconsource();
        let zoom = val;
        let minZoom = this.mapview.minZoom;
        if (this.isMobileflag) {
          let Difference = Math.round(this.jsonOption.screen.pc.view.zoom) - Math.round(this.jsonOption.screen.app.view.zoom);
          console.log(`Difference`, Difference);
          zoom += Difference;
        }
        let orData = [];
        for (let i = minZoom; i <= zoom; i++) {
          orData.push({
            'alias': 'map_level',
            'compt': 'editinput',
            'express': '===',
            'val': i
          });
        }
        this.searchStr.filters.forEach(item => {
          if (item.model === 1) item.filters = orData;
        });
        this.pointform.searchStr = encodeURI(JSON.stringify(this.searchStr));
        this.pointform.page = 1;
        this.pointList = [];
        this.getpointData();
      } else {
        this.$emit('markermoveend', val);
      }
    },
    singleclick(val) {
      this.SET_COORDINATE(val);
    },
    /**
    * 定位点击操作
    * @param {Object} feature 选中数据
    */
    markerclick(feature) {
      console.log(`feature`, feature);
      this.culturalarea = feature === undefined ? '' : feature.get('name') === '渭南市' ? '' : feature.get('name');
      this.typeUlindex = 0;
      this.areaclick(this.culturalarea);

      // this.pointdetail = {}
      // this.popshowflag = false
      // if (!this.isMobileflag) document.querySelector('.map_content').style.zIndex = 2
      // if (feature === undefined) return
      // if (!this.isMobileflag) document.querySelector('.map_content').style.zIndex = 5
      // // 判断feature类型
      // let gtype = feature.getGeometry().getType()
      // if (gtype === 'Point') {
      //     let id = feature.get('id')
      //     let score = feature.get('score')
      //     let cstandardInfo = ''
      //     let cculturalInfo = ''
      //     if (this.pointList.length > 0) cstandardInfo = this.pointList.find(item => { return item.id === id })
      //     if (this.mapculturalList.length > 0) cculturalInfo = this.mapculturalList.find(item => { return item.id === id })
      //     if (cstandardInfo === undefined && cculturalInfo === undefined) return
      //     // 标准模版获取弹窗
      //     if (score === 0) this.standardDetail(cstandardInfo)
      //     // 非遗模版获取弹窗
      //     if (score === 1) this.culturalDetail(cculturalInfo, feature)
      // }
      // if (gtype === 'Polygon' && this.form.ishaschild === '是' && this.id === 1) {
      //     let code = feature.get('code')
      //     let that = this
      //     let mapform = {
      //         deptId: this.query.fid,
      //         formId: '177623',
      //         page: 1,
      //         limit: 100,
      //         searchStr: {
      //             model: 0,
      //             filters: [{
      //                 "model": 0,
      //                 "filters": [{
      //                     'alias': '50',
      //                     'compt': 'editinput',
      //                     'express': 'like',
      //                     'val': code
      //                 }]
      //             }]
      //         }
      //     }
      //     mapform.searchStr = encodeURI(JSON.stringify(mapform.searchStr))
      //     this.$api.singleadvanceSearch(mapform).then((res) => {
      //         if (res.totalRow > 0) {
      //             let cquery = location.hash.split('?')[1]
      //             let cparams = cquery.split('&')
      //             cparams = cparams.map(item => {
      //             let itemarr = item.split('=')
      //                 if (itemarr[0] === 'formUserId') {
      //                     itemarr[1] = res.dataList[0].id
      //                     item = itemarr.join('=')
      //                 }
      //                 return item
      //             })
      //             window.location.href = location.protocol + '//' + location.host + location.pathname + '?page=superMapv2?' + cparams.join('&')
      //         }
      //     })

      // }
    },
    /**
    * 标准模版获取点位详情
    * @param {Object} feature 选中数据
    */
    standardDetail(currentInfo) {
      this.popmodeltype = 0;
      let formatinfo = {};
      Object.keys(currentInfo.itemformdata).forEach(key => {
        formatinfo[key] = currentInfo.itemformdata[key];
      });
      formatinfo.audio = formatinfo.audio.length > 0 ? formatinfo.audio.map(item => {
        item.title = item.name.replace(`.${item.suffix}`, '');
        this.$api.getUrlByObjectId(item.objectId).then(res => {
          item.url = res.http;
        });
        return item;
      }) : '';
      formatinfo.video = formatinfo.video.length > 0 ? formatinfo.video.map(item => {
        item.title = item.name.replace(`.${item.suffix}`, '');
        this.$api.getUrlByObjectId(item.objectId).then(res => {
          item.url = res.http;
        });
        return item;
      }) : '';
      if (formatinfo['42'] === '弹窗') {
        this.pointdetail = formatinfo;
        this.popshowflag = true;
        console.log(`this.pointdetail`, this.pointdetail);
      }
      if (formatinfo['42'] === '链接') {
        if (formatinfo['44'] !== '') {
          if (formatinfo.linkTarget === '是') {
            window.open(formatinfo['44']);
          } else {
            location.href = formatinfo['44'];
          }
        }
      }
    },
    /**
    * 非遗模版获取点位详情
    * @param {Object} feature 选中数据
    */
    culturalDetail(currentInfo, feature) {
      let formatinfo = {};
      let coordinate = feature.xy ? feature.xy : feature.get('xy');
      Object.keys(currentInfo.itemformdata).forEach(key => {
        formatinfo[key] = currentInfo.itemformdata[key];
      });
      formatinfo.coordinate = coordinate;
      formatinfo.gateway = formatinfo.gateway = formatinfo.detailUrl !== '' ? `${formatinfo.detailUrl}&mapid=${formatinfo.number}` : '';
      this.pointdetail = formatinfo;
      this.popshowflag = true;
      this.getCulturalperson(formatinfo);
      this.getCulturalpic(formatinfo);
      this.getCulturalvideo(formatinfo);
      if (this.query.fid === '138053') this.getSeminar(formatinfo);
      if (this.popmodeltype === 1 && !this.isMobileflag) {
        this.$nextTick(() => {
          this.$refs.mapv2assembly.addpopOverLay(coordinate);
        });
      }
    },
    /**
    * 点位获取对应非遗传承人数据
    * @param {Object} feature 选中数据
    */
    getCulturalperson(formatinfo) {
      this.culturalpersonform.deptId = this.query.fid;
      let that = this;
      this.$api.singleadvanceSearchv2(this.culturalpersonform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.culturalpersonform.page === 1) that.mapculturalpersonList = [];
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          that.mapculturalpersonList = that.culturalpersonform.page === 1 ? res.dataList : that.mapculturalpersonList.concat(res.dataList);
          if (res.totalPage > 1) that.culturalpersonform.page++;
          if (res.totalPage > 1 && res.totalPage >= that.culturalpersonform.page) that.getCulturalperson();
        }
      });
    },
    /**
    * 点位获取对应项目图片表单数据
    * @param {Object} feature 选中数据
    */
    getCulturalpic(formatinfo) {
      let searchStr = {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': '19',
            'compt': 'editinput',
            'express': '===',
            'val': formatinfo.number
          }]
        }]
      };
      this.culturalpicform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.culturalpicform.deptId = this.query.fid;
      let that = this;
      this.$api.singleadvanceSearchv2(this.culturalpicform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.culturalpicform.page === 1) that.mapculturalpicList = [];
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          that.mapculturalpicList = that.culturalpicform.page === 1 ? res.dataList : that.mapculturalpicList.concat(res.dataList);
          if (res.totalPage > 1) that.culturalpicform.page++;
          // if (res.totalPage >= that.pointform.page) that.getpointData()
          that.pointdetail.pictureList = that.mapculturalpicList;
        }
      });
    },
    /**
    * 点位获取对应项目视频表单数据
    * @param {Object} feature 选中数据
    */
    getCulturalvideo(formatinfo) {
      let searchStr = {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': '1',
            'compt': 'selectbox',
            'express': '===',
            'val': [formatinfo.title]
          }]
        }]
      };
      this.culturalvideoform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.culturalvideoform.deptId = this.query.fid;
      let that = this;
      this.$api.singleadvanceSearchv2(this.culturalvideoform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.culturalvideoform.page === 1) that.mapculturalvideoList = [];
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          that.mapculturalvideoList = that.culturalvideoform.page === 1 ? res.dataList : that.mapculturalvideoList.concat(res.dataList);
          // if (res.totalPage > 1) that.culturalvideoform.page++
          // if (res.totalPage >= that.pointform.page) that.getpointData()
          that.pointdetail.videoList = that.mapculturalvideoList;
        }
      });
    },
    /**
    * 点位获取对应传习所表 【龙岩地图定制】 202406251652 看后期如何定制 url：seminar202406251701
    * @param {Object} feature 选中数据
    */
    getSeminar(formatinfo) {
      let seminar = {
        formId: '1575388',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '4f4bf90d9e5aaf56878c6788d5471a5acb372f5a11d78917d362ce3fb72373ed'
      };
      let searchStr = {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': '3',
            'compt': 'editinput',
            'express': '===',
            'val': formatinfo.number
          }]
        }]
      };
      seminar.searchStr = encodeURI(JSON.stringify(searchStr));
      seminar.deptId = this.query.fid;
      let that = this;
      this.$api.singleadvanceSearchv2(seminar).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          that.pointdetail.seminarList = res.dataList;
        }
      });
    },
    /**
    * 弹窗关闭事件
    */
    closeHandle() {
      this.popshowflag = false;
      this.pointdetail = {};
    },
    /**
    * 分类选择事件
    */
    typeselect(val) {
      if (this.id === 1) {
        this.typeClick(val);
      } else {
        this.$emit('typeselect', val);
      }
    },
    /**
     * 分类数据格式化
     */
    typebtnFormat(val) {
      let typebtn = [...val];
      this.typebtn = [];
      typebtn.forEach(elem => {
        let item = {
          ...elem
        };
        if (item.imgList && item.imgList.length > 0) {
          item.backgroundImage = 'url(\'' + getImg(item.imgList[0]) + '\')';
          item.backgroundSize = '100% 100%';
          item.backgroundRepeat = 'no-repeat';
        }
        item.textAlign = 'center';
        delete item.imgList;
        let newitem = {};
        Object.keys(item).forEach(child => {
          if (this.isMobileflag) {
            newitem[child] = /px$/.test(item[child]) ? `${parseFloat((parseInt(item[child]) / 2 / 37.5).toFixed(6))}rem` : item[child];
          } else {
            newitem[child] = /px$/.test(item[child]) ? `${parseFloat((parseInt(item[child]) / 1920 * 100).toFixed(6))}vw` : item[child];
          }
        });
        this.typebtn.push(newitem);
      });
    },
    removeAlliconsource() {
      this.$refs.mapv2assembly.removeAlliconsource();
    },
    saveDrawHandle() {
      this.$refs.mapv2assembly.saveDrawHandle();
    },
    updateMap() {
      this.$refs.mapv2assembly.updateMap();
    },
    removeDrawsource() {
      this.$refs.mapv2assembly.removeDrawsource();
    },
    isHasallarea(val) {
      let that = this;
      let mapform = {
        deptId: this.query.fid,
        formId: '177623',
        page: 1,
        limit: 100,
        searchStr: {
          model: 0,
          filters: [{
            "model": 0,
            "filters": [{
              'alias': 'ishaschild',
              'compt': 'radiobutton',
              'express': '===',
              'val': ['是']
            }]
          }]
        }
      };
      mapform.searchStr = encodeURI(JSON.stringify(mapform.searchStr));
      this.$api.singleadvanceSearch(mapform).then(res => {
        if (res.totalRow > 0) {
          this.showgolist = val.ishaschild === '是' ? false : true;
          if (this.showgolist) this.showgolistId = res.dataList[0].id;
        }
      });
    },
    golist() {
      let cquery = location.hash.split('?')[1];
      let cparams = cquery.split('&');
      cparams = cparams.map(item => {
        let itemarr = item.split('=');
        if (itemarr[0] === 'formUserId') {
          itemarr[1] = this.showgolistId;
          item = itemarr.join('=');
        }
        return item;
      });
      window.location.href = location.protocol + '//' + location.host + location.pathname + '?page=superMapv2?' + cparams.join('&');
    },
    /**
     * 获取非遗项目表单结构数据
     */
    getCulturalFormStruct() {
      let params = {
        deptId: this.query.fid,
        formId: 'cultural_heritage_project'
      };
      this.$api.formStruct(params).then(res => {
        this.cstructList = JSON.parse(JSON.stringify(res));
        this.cpList = getformatstruct(res, this.cform, this.cformlabel, this.cformfield, this.cformoption);
        this.defaultcform = Object.assign({}, this.cform);
        this.getCulturalpersonFormStruct();
      });
    },
    setComonStyle() {
      document.querySelector('html').style.fontSize = `${window.screen.width / 10}px`;
    },
    /**
     * 获取地图设置行
     */
    getMapData() {
      let that = this;
      this.$api.singleformUserId(this.query.fid, '177623', this.query.formUserId).then(res => {
        if (res.formUserList.length > 0) {
          that.cformUser = res.formUserList[0];
          let formatData = {};
          res.formUserList[0].formData.forEach(item => {
            formatData[item.alias] = getformitemsdata(item);
          });
          that.formatData = formatData;
          document.title = formatData.toptitle;
          // 处理地图view相关字段
          that.getFormStruct();
        }
      });
    },
    /**
     * 获取地图配置表单结构
     */
    getFormStruct() {
      let params = {
        deptId: this.$route.query.fid,
        formId: 177623
      };
      this.$api.formStruct(params).then(res => {
        this.sList = getformatstruct(res, this.form, this.formlabel, this.formfield, this.formoption);
        this.mapview = this.mapv2info.view;
        this.editlogic(this.formatData);
        this.gettypeList();
      });
    },
    /**
     * 配置页编辑逻辑处理
     */
    editlogic(data) {
      this.mapLayers.json = true;
      this.mapLayers.static = true;
      Object.keys(data).forEach(item => {
        this.form[item] = data[item];
      });
      this.jsonOption = {
        ...JSON.parse(this.form.jsontxt.replace(/(<\/?p.*?>)/gi, ''))
      };
      if (this.jsonOption.screen && Object.keys(this.jsonOption.screen).length > 0) {
        let screenData = this.isMobileflag ? this.jsonOption.screen.app : this.jsonOption.screen.pc;
        Object.keys(screenData).forEach(item => {
          this.jsonOption[item] = screenData[item];
        });
      }
      console.log(`this.jsonOption`, this.jsonOption);
      this.mapviewhandle(this.jsonOption.view);
      this.form.showtype = this.jsonOption.style.showtype;
      this.form.showlist = this.jsonOption.style.showlist;
      this.form.scale = this.jsonOption.view.scale;
      this.form.rotate = this.jsonOption.view.rotate;
      this.SET_MAPFORM(this.form);
      this.SET_MAPVIEW(this.jsonOption.view);
      this.SET_MAPSENIOR(this.jsonOption.senior);
      this.SET_MAPSTYLEITEM({
        showtype: this.jsonOption.style.showtype
      });
      this.SET_MAPSTYLEITEM({
        showlist: this.jsonOption.style.showlist
      });
      this.mapview = this.jsonOption.view;
      this.mapstyle = this.jsonOption.style;
      this.senior = this.jsonOption.senior;
      if (this.form.static_img && this.form.static_img.length > 0) this.mapLayers.staticimage = getImg(this.form.static_img[0]);

      // 判断当前地图模版 score  0标准模版  1非遗模版
      this.formoption.mapTemplate.forEach(elem => {
        if (this.formatData.mapTemplate === elem.title) {
          this.cTemplateScore = elem.score;
          this.SET_MAPFORMITEM({
            cTemplateScore: elem.score
          });
        }
      });
      this.SET_MAPDRAWLAYER(this.jsonOption.drawlayer);
      this.mapLayers.drawelement = this.jsonOption.drawlayer;
      this.mapformHandle(this.form);
      this.$nextTick(() => {
        this.styleHandle(this.jsonOption.style);
        this.typebtnFormat(this.jsonOption.style.typebtn);
        this.popcolorFormat(this.jsonOption.style.popcolor);
      });
      // 是否含有乡镇街道
      if (this.jsonOption.geojson.adcode === undefined) this.mapstreetcode = this.jsonOption.geojson.code;
      let adcode = this.jsonOption.view.adcode;
      if (this.mapstreetcode !== '') {
        axios.get(`${process.env.NODE_ENV === 'development' ? '/fileapi' : location.origin}/frontendTest1/openlayers/data/${adcode}.json`).then(res => {
          if (res.status === 200) {
            let cjson = res.data.features.filter(item => {
              return Number(item.properties.code) === Number(this.mapstreetcode);
            });
            if (cjson.length > 0) {
              let datacoord = cjson[0].geometry.coordinates[0];
              let changedata = [];
              datacoord.forEach(elem => {
                changedata.push(transform(elem, 'EPSG:4326', 'EPSG:3857'));
              });
              cjson[0].geometry.coordinates[0] = changedata;
              this.mapLayers.geojson = {
                type: 'FeatureCollection',
                features: cjson
              };
              this.loadingmap = true;
            }
          }
        }).catch(error => {});
        return;
      }
      this.loadingmap = true;
    },
    mapviewhandle(view) {
      let center = view.center;
      this.form.centerX = center[0];
      this.form.centerY = center[1];
      this.form.minZoom = view.minZoom;
      this.form.maxZoom = view.maxZoom;
      this.form.zoom = view.zoom;
      this.form.static_map_min_level = view.minZoom;
      this.form.static_map_max_level = view.maxZoom;
      this.form.current_level = view.zoom;
      this.form.map_center = center.join(',');
      this.form.transform_extent = view.extent.join(',');
    },
    /**
     * 获取分类列表数据
     */
    gettypeList() {
      let that = this;
      this.typeform.deptId = this.query.fid;
      this.$api.singleadvanceSearch(this.typeform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          that.typeList = [];
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          this.typeList = res.dataList.sort((a, b) => Number(a.itemformdata.sortId) - Number(b.itemformdata.sortId));
        }

        // 处理地点管理表 请求参数
        this.pointform.deptId = this.query.fid;
        this.searchStr.filters[0].filters[0].val = this.formatData.title || this.formatData['46'];
        this.pointform.searchStr = encodeURI(JSON.stringify(this.searchStr));
        this.getpointData();

        // 处理非遗项目表单数据
        if (this.cTemplateScore === 1) {
          this.culturalform.deptId = this.query.fid;
          // this.getCustomstatistics()
          if (this.isMobileflag) this.removeDrawsource();
        }
      });
    },
    /**
     * 获取地点管理表数据
     */
    getpointData() {
      let that = this;
      this.$api.singleadvanceSearch(this.pointform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.pointform.page === 1) that.pointList = [];
          that.pointdataformat(res);
          if (res.totalPage > 1) that.pointform.page++;
          // if (res.totalPage > 1 && res.totalPage >= that.pointform.page) that.getpointData()
        }
      });
    },
    pointdataformat(res) {
      res.dataList.forEach((item, index) => {
        let itemformdata = item.formIdValueData;
        let itemformat = {};
        Object.keys(itemformdata).forEach(key => {
          itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
        });
        item.itemformdata = itemformat;
      });
      this.pointList = this.pointform.page === 1 ? res.dataList : this.dataList.concat(res.dataList);
    },
    /**
     * 点击类型操作
     * @param {Object} data 选中数据及索引 index item
     */
    typeClick(data) {
      this.popshowflag = false;
      this.removeAlliconsource();
      let dindex = data.index;
      let val = dindex === 0 ? '' : data.item.itemformdata;
      let typesearchflag = false;
      if (dindex === 0) {
        this.searchStr.filters.forEach((item, index) => {
          if (item.filters.length > 0 && item.filters[0].alias === 'map_type2') this.searchStr.filters.splice(index, 1);
        });
      } else {
        this.searchStr.filters.forEach(item => {
          if (item.filters.length > 0 && item.filters[0].alias === 'map_type2') {
            item.filters[0].val = val.title;
            typesearchflag = true;
          }
        });
        if (!typesearchflag) {
          this.searchStr.filters.push({
            "model": 0,
            "filters": [{
              'alias': 'map_type2',
              'compt': 'editinput',
              'express': '===',
              'val': val.title
            }]
          });
        }
      }
      this.pointform.searchStr = encodeURI(JSON.stringify(this.searchStr));
      this.pointform.page = 1;
      this.pointList = [];
      this.getpointData();
    },
    /**
     * 获取非遗项目表单数据
     */
    getIntangibleCulturalHeritageData() {
      let that = this;
      this.$api.singleadvanceSearchv2(this.culturalform).then(res => {
        if (res.totalRow > 0) {
          if (that.culturalform.page === 1) that.mapculturalList = [];
          that.culturaldataformat(res);
          if (res.totalPage > 1) that.culturalform.page++;
          if (res.totalPage > 1 && res.totalPage >= that.culturalform.page) that.getIntangibleCulturalHeritageData();
        }
      });
    },
    culturaldataformat(res) {
      res.dataList.forEach((item, index) => {
        let itemformdata = item.formIdValueData;
        let itemformat = {};
        Object.keys(itemformdata).forEach(key => {
          itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
        });
        if (this.typeList.length > 0) {
          let type = this.typeList.find(elem => {
            return elem.itemformdata.title === itemformat.level;
          });
          if (type && type.itemformdata.icon.length > 0) itemformat.icon = getImg(type.itemformdata.icon[0]);
        }
        item.itemformdata = itemformat;
      });
      this.mapculturalList = this.culturalform.page === 1 ? res.dataList : this.mapculturalList.concat(res.dataList);
    },
    /**
    * 获取非遗传承人数据
    */
    getCulturalpersonFormStruct() {
      let params = {
        deptId: this.query.fid,
        formId: 'cultural_heritage_inheritor'
      };
      this.$api.formStruct(params).then(res => {
        let data = JSON.parse(JSON.stringify(res));
        data.forEach(item => {
          if (item.alias === 'category') this.culturalpersoncategory = item.field.options;
        });
        this.getworkshopFormStruct();
      });
    },
    /**
    * 获取非遗工坊数据
    */
    getworkshopFormStruct() {
      let params = {
        deptId: this.query.fid,
        formId: 'cultural_heritage_workshop'
      };
      this.$api.formStruct(params).then(res => {
        let data = JSON.parse(JSON.stringify(res));
        data.forEach(item => {
          if (item.alias === 'level') this.culturalworkshoplevel = item.field.options;
        });
        this.getCustomstatistics();
      });
    },
    /**
    * 按申报地区统计数据
    */
    areaclick(area) {
      this.culturalarea = area !== undefined || area !== '' ? area : '';
      this.getCustomstatistics(area);
    },
    openCategory(title) {
      let area = this.culturalarea;
      if (this.typeUlindex === 0) {
        window.open(`https://all.chaoxing.com/cultural_heritage_resources/web/views/feiyi.html?category=${title}&address=${area}&wfwfid=138061&pageId=1130626&websiteId=588206&mhType=1&publicId=c4eeb82243394111ef1ba988ff65ba53f7d3&mhEnc=9acf4d871b4e21c3db362f23be7bfe67`);
      }
      if (this.typeUlindex === 1) {
        window.open(`https://all.chaoxing.com/cultural_heritage_resources/web/views/feiyi.html?pageId=1130626&wfwfid=138061&websiteId=588206&typeCcr=2&category=${title}&address=${area}`);
      }
      if (this.typeUlindex === 2) {
        window.open(`https://all.chaoxing.com/cultural_heritage_resources/web/views/workshop.html?pageId=1130626&wfwfid=138061&websiteId=588206&id=fyml000000466&level=${title}&address=${area}`);
      }
    },
    /**
    * 获取地图统计优化表单数据
    */
    getCustomstatistics(area) {
      console.log(`area`, area);
      let searcha = {};
      if (area !== undefined && area !== '') {
        searcha = {
          filters: [[{
            alias: "address",
            compt: "selectbox",
            express: "===",
            range: null,
            val: [area]
          }]],
          model: 0
        };
      }
      this.culturalprojectData = this.cformoption.category.map(item => {
        return {
          title: item.title
        };
      });
      this.culturalprojectDatalen = 0;
      let formData = {
        deptId: this.$route.query.fid,
        formAlias: this.culturalform.formId,
        searchStr: area !== undefined && area !== '' ? encodeURI(JSON.stringify(searcha)) : '',
        groupFieldId: 5,
        statsFieldId: 101,
        statsType: 'sum'
      };
      this.$api.getStatistics(formData).then(res => {
        if (Object.keys(res.resultMap).length > 0) {
          this.culturalprojectData.forEach(item => item.sum = 0);
          Object.keys(res.resultMap).forEach(key => {
            this.culturalprojectData.forEach(item => {
              if (item.title === key) {
                item.sum = res.resultMap[key].value;
                this.culturalprojectDatalen += item.sum;
              }
            });
          });
        }
      });
      this.$api.singleadvanceSearchv2({
        deptId: this.query.fid,
        formAlias: this.culturalform.formId,
        page: 1,
        limit: 100,
        searchStr: area !== undefined && area !== '' ? encodeURI(JSON.stringify(searcha)) : '',
        onlyReturnCount: 1,
        t: this.culturalform.t
      }).then(res => {
        this.culturalprojectSum = res.totalRow;
      });
      this.culturalpersonData = this.culturalpersoncategory.map(item => {
        return {
          title: item.title
        };
      });
      this.culturalpersoncategorylen = 0;
      let formData1 = {
        deptId: this.$route.query.fid,
        formAlias: 'cultural_heritage_inheritor',
        searchStr: area !== undefined && area !== '' ? encodeURI(JSON.stringify(searcha)) : '',
        groupFieldId: 25,
        statsFieldId: 57,
        statsType: 'sum'
      };
      this.$api.getStatistics(formData1).then(res => {
        if (Object.keys(res.resultMap).length > 0) {
          this.culturalpersonData.forEach(item => item.sum = 0);
          Object.keys(res.resultMap).forEach(key => {
            this.culturalpersonData.forEach(item => {
              if (item.title === key) {
                item.sum = res.resultMap[key].value;
                this.culturalpersoncategorylen += item.sum;
              }
            });
          });
        }
      });
      this.$api.singleadvanceSearchv2({
        deptId: this.query.fid,
        formAlias: this.culturalpersonform.formId,
        page: 1,
        limit: 100,
        searchStr: area !== undefined && area !== '' ? encodeURI(JSON.stringify(searcha)) : '',
        onlyReturnCount: 1,
        t: this.culturalpersonform.t
      }).then(res => {
        this.culturalpersonSum = res.totalRow;
      });
      this.culturalworkshoplevellen = 0;
      let formData2 = {
        deptId: this.$route.query.fid,
        formAlias: 'cultural_heritage_workshop',
        searchStr: area !== undefined && area !== '' ? encodeURI(JSON.stringify(searcha)) : '',
        groupFieldId: 2,
        statsFieldId: 5,
        statsType: 'sum'
      };
      this.$api.getStatistics(formData2).then(res => {
        if (Object.keys(res.resultMap).length > 0) {
          this.culturalworkshoplevel.forEach(item => item.sum = 0);
          Object.keys(res.resultMap).forEach(key => {
            this.culturalworkshoplevel.forEach(item => {
              if (item.title === key) {
                item.sum = res.resultMap[key].value;
                this.culturalworkshoplevellen += item.sum;
              }
            });
          });
        }
      });
    },
    getValue(val) {
      return val === undefined ? 0 : val;
    }
  }
};